import React, { lazy } from 'react';
import HeroSection from '../components/sections/HeroSection';
import StatsSection from '../components/sections/StatsSection';
import TrustSection from '../components/sections/TrustSection';
import ServicesSection from '../components/sections/ServicesSection';
import AssessmentSection from '../components/sections/AssessmentSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import SEO from '../components/ui/SEO';
const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'MedicalBusiness',
  name: 'Medicolegal Psychiatry',
  url: 'https://medicolegal-psychiatry.co.uk/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png',
  address: {
    '@type': 'PostalAddress',
    addressRegion: 'Warwickshire',
    addressCountry: 'UK'
  },
  email: 'enquiries@medicolegal-psychiatry.co.uk',
  areaServed: ['England', 'Wales'],
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '17:00'
  }, {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: 'Saturday',
    opens: '09:00',
    closes: '13:00'
  }],
  medicalSpecialty: 'Psychiatry',
  founder: {
    '@type': 'Person',
    name: 'Dr Imtiaz Syed',
    jobTitle: 'Independent Psychiatric Expert Witness'
  },
  description: 'Court-ready psychiatric expert witness reports for solicitors and barristers across England and Wales.'
};
export default function Home() {
  return <main className="min-h-screen bg-white" data-id="element-523" data-mp="287ktpqc2lnyi">
      <SEO title="Psychiatric Expert Witness Reports UK | Dr Imtiaz Syed" description="Court-ready psychiatric expert witness reports for solicitors and barristers across England and Wales. CPR Part 35 compliant. Instruct Dr Syed today." path="/" keywords={['psychiatric expert witness reports', 'independent psychiatric expert witness', 'medico-legal psychiatric reports', 'psychiatric expert witness England and Wales']} imageAlt="Medicolegal Psychiatry, independent psychiatric expert witness reports" schema={homeSchema} data-id="element-524" data-mp="288dri1t1x34i" />
      <HeroSection data-id="element-525" data-mp="1flmfyud6aqqs" />
      <StatsSection data-id="element-526" data-mp="1fl49z60pky5o" />
      <TrustSection data-id="element-527" data-mp="1fmfcz3mby1vq" />
      <ServicesSection data-id="element-528" data-mp="1flw7imdv95yl" />
      <AssessmentSection data-id="element-529" data-mp="1fngyk20z26rp" />
      <TestimonialsSection data-id="element-530" data-mp="23aowfyw2mdjp" />
      <section className="py-8 bg-gray-50 border-t border-gray-200" data-id="element-531" data-mp="23cjf16jvdtkm">
        <div className="container mx-auto px-4" data-id="element-532" data-mp="28atf9vkgbkd3">
          <div className="flex items-center justify-center gap-3" data-id="element-533" data-mp="289ic9xytygn1">
            <span className="text-slate text-sm" data-id="element-534" data-mp="1tkdmnvppha4w">Website created by</span>
            <a href="https://bright-pixxel.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 transition-opacity hover:opacity-80" data-id="element-535" data-mp="1yjynycscluks">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/spdsZGPouzsb8mdDCE9yxi/Geometric_Logo_of_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studio Web Design" className="h-8 w-auto" loading="lazy" data-id="element-536" data-mp="2r1ktbafdvyxt" />
              <span className="font-semibold text-primary" data-id="element-537" data-mp="ocud7t0z4xrd">
                Bright Pixxel Studio
              </span>
            </a>
          </div>
        </div>
      </section>
    </main>;
}